import styled from "styled-components";

export const StyledListItemContainer = styled.div<{ index: number }>`
    animation: slide-up ease-out 400ms ${({ index }) => index * 50}ms forwards;
    margin-bottom: 16px;
    opacity: 0;
    transform: translateY(20px);
    width: calc(50% - 26px / 2);

    &:nth-child(odd) {
        margin-right: 20px;
    }

    @keyframes slide-up {
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;
